import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as R from 'ramda';

import { FormsModule } from '@angular/forms';
import { NbSelectModule, NbOptionModule } from '@nebular/theme';

@Component({
    selector: 'app-year-selector',
    styleUrls: ['./year-selector.component.scss'],
    templateUrl: './year-selector.component.html',
    standalone: true,
    imports: [
    NbSelectModule,
    FormsModule,
    NbOptionModule
],
})
export class YearSelectorComponent implements OnInit {

  @Input() public year: number;
  @Input() public minYear: number;
  @Input() public maxYear: number;
  @Output() public yearChanged = new EventEmitter<number>();

  public showArrows: boolean = false;
  public yearsAvailable: number[] = [];

  constructor(
  ) { }

  ngOnInit(): void {
    const now = new Date().getFullYear();
    if (this.minYear && this.maxYear) {
      this.yearsAvailable = R.range(this.minYear, this.maxYear + 1);
    } else {
      this.yearsAvailable = R.range(now - 15, 2056);
    }
  }

  public toggleArrows(display: boolean): void {
    this.showArrows = display;
  }

  public changeYear(year: number): void {
    this.year = year;
    this.yearChanged.emit(this.year);
  }

}
